export default {

  /** 验证码 */
  getVerifyCode: '/ygsjzs/getVerifyCode',
  /** 短信验证码 */
  smsCode: '/ygsjzs/smsCode',
  /** 短信登录 */
  smsLogin: '/ygsjzs/smsLogin',
  /** 登录 */
  login: '/ygsjzs/login',
  /** 省市区 */
  selectCity: '/ygsjzs/dic/selectCity',
  /** 文件上传 */
  uploadUrl: '/ygsjzs/fdfs/upload',
  updateUrl: '/ygsjzs/fdfs/update',
  /** 数据字典 */
  selectDicByList: '/ygsjzs/dic/selectDicByList',
  // 用户列表
  selectIparkUserByList: '/ygsjzs/iparkUser/selectIparkUserByList'
}
